/* @stayai: when a PDP product has a "Legacy" selling plan group, log every other selling plan group attached to it and hide the subscription purchase-option label */
(function () {
  var HIDE_TARGET_SELECTOR =
    "purchase-options .stayai-subscription .stayai-widget label.stayai-purchase-label[for='purchaseTypeSubscription']";

  var HIDE_STYLE_ID = 'stayai-legacy-hide-subscription-label';

  function hideSubscriptionLabel() {
    /* @stayai: stayai-pdp widget renders async (deferred module) — a CSS rule matches it
       whenever it shows up, so we don't have to wait/observe for the element */
    if (document.getElementById(HIDE_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = HIDE_STYLE_ID;
    style.textContent = HIDE_TARGET_SELECTOR + ' { display: none !important; }';
    document.head.appendChild(style);
  }

  function getSellingPlanGroups() {
    if (Array.isArray(window.ALL_SELLING_PLAN_GROUPS)) {
      return window.ALL_SELLING_PLAN_GROUPS;
    }

    var productJsonEl = document.querySelector('script[id^="ProductJson-"]');
    if (!productJsonEl) return null;

    try {
      var product = JSON.parse(productJsonEl.textContent);
      return product.selling_plan_groups || [];
    } catch (e) {
      return null;
    }
  }

  function run() {
    var groups = getSellingPlanGroups();
    if (!Array.isArray(groups) || groups.length === 0) return;

    var isLegacy = function (group) {
      return (group.name || '').toLowerCase().indexOf('legacy') !== -1;
    };

    var legacyGroups = groups.filter(isLegacy);
    if (legacyGroups.length === 0) return;

    legacyGroups.forEach(function (group) {
      console.log('>>> legacy selling plan group name:', group.name);
    });

    hideSubscriptionLabel();

    var otherGroups = groups.filter(function (group) {
      return !isLegacy(group);
    });

    if (otherGroups.length === 0) {
      console.log('>>> Legacy selling plan group found on this product; no other selling plan groups attached');
      return;
    }

    console.log('>>> Legacy selling plan group found — other selling plan groups on this product:', otherGroups);
    otherGroups.forEach(function (group) {
      console.log('>>> other selling plan group:', group.name, '| app_id:', group.app_id, '| id:', group.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
